import {
  checkHttpStatus,
  getApiHeaders,
  getApiBaseUrlWithOrg
} from '../utils/api'
import { push } from 'connected-react-router'

export const FETCH_ACADEMIC_YEARS_REQUEST = 'FETCH_ACADEMIC_YEARS_REQUEST'
export const FETCH_ACADEMIC_YEARS_SUCCESS = 'FETCH_ACADEMIC_YEARS_SUCCESS'
export const SET_ACTIVE_TERM = 'SET_ACTIVE_TERM'

export const fetchAcademicYearsRequest = () => ({
  type: FETCH_ACADEMIC_YEARS_REQUEST
})

export const fetchAcademicYearsSuccess = academicYears => ({
  type: FETCH_ACADEMIC_YEARS_SUCCESS,
  payload: {
    academicYears
  }
})

export function fetchAcademicYears() {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/academic_years`

    dispatch(fetchAcademicYearsRequest())

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'GET',
          headers: getApiHeaders(state)
        })
      )
      const data = await response.json()

      dispatch(fetchAcademicYearsSuccess(data))
    } catch (error) {
      if (error.response.status === 404) {
        dispatch(push('/notfound'))
      }

      if (error.response.status === 500) {
        dispatch(push('/error'))
      }
    }
  }
}

export const setActiveTerm = activeTerm => ({
  type: SET_ACTIVE_TERM,
  payload: {
    activeTerm
  }
})
